import React from "react";
import { Checkbox, Label, Switch, Textarea, Tooltip } from "@panda0/panda0-ui";
import { Controller, useFormContext } from "react-hook-form";

import { FormData } from "../types";

const FormDetailsEditor: React.FC = () => {
  const { control, watch } = useFormContext<FormData>();
  const formDetails = watch("formDetails");

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">
        Configure which fields are required in the application form.
      </p>

      <div className="space-y-4">
        {/* Resume Required */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">Resume Required</label>
          <div className="flex items-center space-x-4">
            <Controller
              name="formDetails.FORMSETTINGS_RESUMEREQUIRED"
              control={control}
              render={({ field }) => (
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              )}
            />
            <div className="flex items-center space-x-2">
              <Controller
                name="formDetails.ISREQUIRED_FORMSETTINGS_RESUMEREQUIRED"
                control={control}
                render={({ field }) => (
                  <>
                    <Checkbox
                      id="formDetails.ISREQUIRED_FORMSETTINGS_CTCREQUIRED"
                      checked={field.value || false}
                      onCheckedChange={(checked) =>
                        field.onChange(checked as boolean)
                      }
                    />
                    <Label
                      className="select-none text-sm font-medium text-neutral-600 hover:text-neutral-800"
                      htmlFor="formDetails.ISREQUIRED_FORMSETTINGS_RESUMEREQUIRED"
                    >
                      Is Mandatory
                    </Label>
                  </>
                )}
              />
            </div>
          </div>
        </div>

        {/* Contact Number */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">Contact Number</label>
          <div className="flex items-center space-x-4">
            <Controller
              name="formDetails.FORMSETTINGS_CONTACTNUMBEREQUIRED"
              control={control}
              render={({ field }) => (
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              )}
            />
            <div className="flex items-center space-x-2">
              <Controller
                name="formDetails.ISREQUIRED_FORMSETTINGS_CONTACTNUMBEREQUIRED"
                control={control}
                render={({ field }) => (
                  <>
                    <Checkbox
                      id="formDetails.ISREQUIRED_FORMSETTINGS_CONTACTNUMBEREQUIRED"
                      checked={field.value || false}
                      onCheckedChange={(checked) =>
                        field.onChange(checked as boolean)
                      }
                    />
                    <Label
                      className="select-none text-sm font-medium text-neutral-600 hover:text-neutral-800"
                      htmlFor="formDetails.ISREQUIRED_FORMSETTINGS_CONTACTNUMBEREQUIRED"
                    >
                      Is Mandatory
                    </Label>
                  </>
                )}
              />
            </div>
          </div>
        </div>

        {/* Location */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">Location</label>
          <div className="flex items-center space-x-4">
            <Controller
              name="formDetails.FORMSETTINGS_LOCATIONREQUIRED"
              control={control}
              render={({ field }) => (
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              )}
            />
            <div className="flex items-center space-x-2">
              <Controller
                name="formDetails.ISREQUIRED_FORMSETTINGS_LOCATIONREQUIRED"
                control={control}
                render={({ field }) => (
                  <>
                    <Checkbox
                      id="formDetails.ISREQUIRED_FORMSETTINGS_LOCATIONREQUIRED"
                      checked={field.value || false}
                      onCheckedChange={(checked) =>
                        field.onChange(checked as boolean)
                      }
                    />
                    <Label
                      className="select-none text-sm font-medium text-neutral-600 hover:text-neutral-800"
                      htmlFor="formDetails.ISREQUIRED_FORMSETTINGS_LOCATIONREQUIRED"
                    >
                      Is Mandatory
                    </Label>
                  </>
                )}
              />
            </div>
          </div>
        </div>

        {/* LinkedIn Profile */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">LinkedIn Profile</label>
          <div className="flex items-center space-x-4">
            <Controller
              name="formDetails.FORMSETTINGS_LINKEDINREQUIRED"
              control={control}
              render={({ field }) => (
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              )}
            />
            <div className="flex items-center space-x-2">
              <Controller
                name="formDetails.ISREQUIRED_FORMSETTINGS_LINKEDINREQUIRED"
                control={control}
                render={({ field }) => (
                  <>
                    <Checkbox
                      id="formDetails.ISREQUIRED_FORMSETTINGS_LINKEDINREQUIRED"
                      checked={field.value || false}
                      onCheckedChange={(checked) =>
                        field.onChange(checked as boolean)
                      }
                    />
                    <Label
                      className="select-none text-sm font-medium text-neutral-600 hover:text-neutral-800"
                      htmlFor="formDetails.ISREQUIRED_FORMSETTINGS_LINKEDINREQUIRED"
                    >
                      Is Mandatory
                    </Label>
                  </>
                )}
              />
            </div>
          </div>
        </div>

        {/* GitHub Profile */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">GitHub Profile</label>
          <div className="flex items-center space-x-4">
            <Controller
              name="formDetails.FORMSETTINGS_GITHUBREQUIRED"
              control={control}
              render={({ field }) => (
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              )}
            />
            <div className="flex items-center space-x-2">
              <Controller
                name="formDetails.ISREQUIRED_FORMSETTINGS_GITHUBREQUIRED"
                control={control}
                render={({ field }) => (
                  <>
                    <Checkbox
                      id="formDetails.ISREQUIRED_FORMSETTINGS_GITHUBREQUIRED"
                      checked={field.value || false}
                      onCheckedChange={(checked) =>
                        field.onChange(checked as boolean)
                      }
                    />
                    <Label
                      className="select-none text-sm font-medium text-neutral-600 hover:text-neutral-800"
                      htmlFor="formDetails.ISREQUIRED_FORMSETTINGS_GITHUBREQUIRED"
                    >
                      Is Mandatory
                    </Label>
                  </>
                )}
              />
            </div>
          </div>
        </div>

        {/* Education Qualification */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">Education Qualification</label>
          <div className="flex items-center space-x-4">
            <Controller
              name="formDetails.FORMSETTINGS_EDUCATIONREQUIRED"
              control={control}
              render={({ field }) => (
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              )}
            />
            <div className="flex items-center space-x-2">
              <Controller
                name="formDetails.ISREQUIRED_FORMSETTINGS_EDUCATIONREQUIRED"
                control={control}
                render={({ field }) => (
                  <>
                    <Checkbox
                      id="formDetails.ISREQUIRED_FORMSETTINGS_EDUCATIONREQUIRED"
                      checked={field.value || false}
                      onCheckedChange={(checked) =>
                        field.onChange(checked as boolean)
                      }
                    />
                    <Label
                      className="select-none text-sm font-medium text-neutral-600 hover:text-neutral-800"
                      htmlFor="formDetails.ISREQUIRED_FORMSETTINGS_EDUCATIONREQUIRED"
                    >
                      Is Mandatory
                    </Label>
                  </>
                )}
              />
            </div>
          </div>
        </div>

        {/* Current CTC */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">Current CTC</label>
          <div className="flex items-center space-x-4">
            <Controller
              name="formDetails.FORMSETTINGS_CTCREQUIRED"
              control={control}
              render={({ field }) => (
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              )}
            />
            <div className="flex items-center space-x-2">
              <Controller
                name="formDetails.ISREQUIRED_FORMSETTINGS_CTCREQUIRED"
                control={control}
                render={({ field }) => (
                  <>
                    <Checkbox
                      id="formDetails.ISREQUIRED_FORMSETTINGS_CTCREQUIRED"
                      checked={field.value || false}
                      onCheckedChange={(checked) =>
                        field.onChange(checked as boolean)
                      }
                    />
                    <Label
                      className="select-none text-sm font-medium text-neutral-600 hover:text-neutral-800"
                      htmlFor="formDetails.ISREQUIRED_FORMSETTINGS_CTCREQUIRED"
                    >
                      Is Mandatory
                    </Label>
                  </>
                )}
              />
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t my-4"></div>

        {/* Candidate Consent */}
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium">
            Candidate Consent Required
          </label>
          <Controller
            name="formDetails.FORMSETTINGS_CANDIDATECONSENTREQUIRED"
            control={control}
            render={({ field }) => (
              <div className="flex items-center space-x-4">
                <Switch
                  checked={field.value || false}
                  fn={(checked) => field.onChange(checked as boolean)}
                />
              </div>
            )}
          />
        </div>

        {formDetails?.FORMSETTINGS_CANDIDATECONSENTREQUIRED && (
          <div className="space-y-2">
            <label className="block text-sm font-medium">Consent Text</label>
            <Controller
              name="formDetails.FORMSETTINGS_CONSENTTEXT"
              control={control}
              render={({ field }) => (
                <Textarea
                  placeholder="I agree to share my data for employment purposes..."
                  className="h-24"
                  value={field.value || ""}
                  onChange={(e) => field.onChange(e.target.value)}
                />
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(FormDetailsEditor);
